import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function Layout({ children }) {
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <div className="d-flex">
      <Sidebar show={showSidebar} onHide={() => setShowSidebar(false)} />
      <div className="flex-grow-1" style={{ minWidth: 0 }}>
        <Topbar onToggleSidebar={() => setShowSidebar(true)} />
        <div className="p-3 p-md-4">{children}</div>
      </div>
    </div>
  );
}
